<template>
  <section class="section-product">
    <aside class="left">
      <img
        :src="dataProduct[0].img_product[0]"
        :alt="dataProduct[0].description_product_custom"
      />
    </aside>
    <aside class="rigth">
      <h1>{{ dataProduct[0].name_product }}</h1>
      <p class="brand">
        Marca: <span>{{ dataProduct[0].brand_product }}</span>
      </p>
      <br />
      <div class="description">
        <p>Descripcion:</p>

        <p>{{ dataProduct[0].description_product_custom }}.</p>
        <p>{{ dataProduct[0].description_product_general }}.</p>
      </div>
      <a
        :href="dataProduct[0].technical_datasheet"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ficha Tecnica
      </a>
      <br/>
      <form @submit.prevent="" class="add-cot">
        <input
          type="number"
          name=""
          id=""
          placeholder="Cantidad"
          class="input input-cant"
          v-model="productQuantity"
        />
        <input
          type="submit"
          value="Agregar a cotizar"
          class="btn btn-addcot"
          @click="() => addToCartShopping()"
        />
      </form>
    </aside>
  </section>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref } from "vue";
import products from "@/data/products.json";
import { useCartShoppingStore } from "@/store/cartshopping";
import { onMounted } from "vue";

const cartShop = useCartShoppingStore();
const route = useRouter();
const dataProduct = ref();
const productQuantity = ref(1);
const idProduct = route.currentRoute.value.query.id;

dataProduct.value = products.filter((item) => {
  return item.id == idProduct;
});

function addToCartShopping() {
  // Verificar si el producto ya está en el carrito
  const existingProduct = cartShop.cart.find((item) => item.id === idProduct);
  if (existingProduct) {
    existingProduct.quantity = productQuantity.value;
    return;
  }
  cartShop.addToCart(dataProduct.value[0], productQuantity.value);
}

function setMeta() {  
  document.title = dataProduct.value[0].name_product  + ' ' + dataProduct.value[0].description_product_general;
}
onMounted(setMeta)

</script>

<style lang="scss" scoped>
.section-product {
  padding-top: 120px;
  padding-inline: 300px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .left {
    flex: 1;
    img {
      width: 420px;
    }
  }
  .rigth {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: start;
    h1 {
      font-size: 48px;
    }
    .brand {
      font-size: 20px;
    }
    .brand span {
      font-weight: 600;
      color: $colorPrimary;
    }
    .description {
      display: flex;
      flex-direction: column;
      text-align: start;
      gap: 6px;
      opacity: 0.8;
    }
    .add-cot {
      width: 100%;
      display: flex;
      flex-direction: row;
      gap: 20px;
      flex-flow: column;
      .input-cant {
        padding-block: 20px;
        padding-inline: 15px;
        font-size: 16px;
        border-radius: 5px;
        border: 1px solid rgba(128, 128, 128, 0.212);
        outline: none;
      }
      .btn-addcot {
        font-size: 18px;
        border-radius: 5px;
        border: none;
        outline: none;
        padding-block: 20px;
        background-color: $tint1;
        color: $whited;
      }
    }
  }
}

@media (max-width: 1600px) {
  .section-product {
    padding-inline: 100px;
    .left {
      img {
        width: 320px;
      }
    }
    .rigth {
      h1 {
        font-size: 38px;
      }
    }
  }
}
@media (max-width: 1080px) {
  .section-product {
    padding-inline: 80px;
    .left {
      img {
        width: 260px;
      }
    }
    .rigth {
      h1 {
        font-size: 32px;
      }
    }
  }
}
@media (max-width: 880px) {
  .section-product {
    padding-inline: 80px;
    display: flex;
    flex-direction: column;
    align-items: start;
    .left {
      width: 100%;
      margin-bottom: 40px;
    }
    .rigth {
      width: 100%;
    }
  }
}

@media (max-width: 580px) {
  .section-product {
    padding-inline: 20px;
    .rigth {
      h1 {
        font-size: 24px;
      }
    }
  }
}
</style>
